var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _rect8, _rect9, _path3, _path4, _rect0, _rect1, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDonationCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 122,
    viewBox: "0 0 162 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 161,
    height: 121,
    rx: 4.5,
    fill: "#F8F8F8",
    stroke: "#CCCCCC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.75,
    y: 16.75,
    width: 48.5,
    height: 88.5,
    rx: 3.25,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 89,
    width: 30,
    height: 7,
    rx: 3.5,
    fill: "#68C598"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 26,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 33,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 37,
    width: 30,
    height: 1,
    rx: 0.5,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 40,
    width: 30,
    height: 1,
    rx: 0.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 50.5C31 49.6716 31.6716 49 32.5 49H45V52H32.5C31.6716 52 31 51.3284 31 50.5Z",
    fill: "#BBBBBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49H59.5C60.3284 49 61 49.6716 61 50.5C61 51.3284 60.3284 52 59.5 52H47V49Z",
    fill: "#BBBBBB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 55,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 59,
    width: 30,
    height: 1,
    rx: 0.5,
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 68.5C31 67.6716 31.6716 67 32.5 67H45V70H32.5C31.6716 70 31 69.3284 31 68.5Z",
    fill: "#BBBBBB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47 67H59.5C60.3284 67 61 67.6716 61 68.5C61 69.3284 60.3284 70 59.5 70H47V67Z",
    fill: "#BBBBBB"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 73,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#D9D9D9"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 77,
    width: 30,
    height: 1,
    rx: 0.5,
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139 39H94V84H139V39ZM137.058 41.0254H96.0264V82.0879H137.058V41.0254Z",
    fill: "#68C598"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.063 70.2763L111.147 56.9023L98.29 76.1881H115.925L115.857 76.2849H133.857L124.857 63.4277L120.063 70.2763Z",
    fill: "#68C598"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.488 59.5848C130.362 59.5848 132.691 57.2791 132.691 54.435C132.691 51.5908 130.362 49.2852 127.488 49.2852C124.615 49.2852 122.286 51.5908 122.286 54.435C122.286 57.2791 124.615 59.5848 127.488 59.5848Z",
    fill: "#68C598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationCard);
export default __webpack_public_path__ + "static/media/donation-card.1138bacaff08d400cab913f9528d7148.svg";
export { ForwardRef as ReactComponent };